import React from 'react';
import EventPageTemplate from './EventPageTemplate';
import { eventData } from '../data/eventContent';

const SpecialOccasionsPage: React.FC = () => {
  // Use private-parties data for special occasions as they are very similar
  return <EventPageTemplate {...eventData['special-occasions']} title="Speciale Gelegenheden" id="special-occasions" />;
};

export default SpecialOccasionsPage;